import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Pengeheftelse from './Pengeheftelse.jsx'
import CollapseIcon from '../../../../images/expand copy 3.png'
import ExpandIcon from '../../../../images/collapse copy 3.png'
import PilIcon from '../../../../images//Icon_Pil-ny.png'

class PengeheftelseList extends Component {
    state = {
        pengeheftelser: [],
        isPengeheftelserLoaded: false,
        isLoading: false,
        isOpened: false
    }

    getPengeheftelser = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/pengeheftelse/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.props.kommunenummer,
                gardsnummer: this.props.gardsnummer,
                bruksnummer: this.props.bruksnummer,
                festenummer: this.props.festenummer,
                seksjonsnummer: this.props.seksjonsnummer
            }
        })
        .then(({data}) => {
            this.setState({
                pengeheftelser: [...this.state.pengeheftelser, ...data.pengeheftelser],
                isPengeheftelserLoaded: true,
                isLoading: false})
        })
      }


    togglePengeheftelser = () => {
        if (!this.state.isPengeheftelserLoaded) {
            this.getPengeheftelser()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        return (
            <li>
                <div className="section-header subsection" onClick={this.togglePengeheftelser}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={PilIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }                    
                    <span className="title">{t('pengeheftelser')} {this.state.isPengeheftelserLoaded && `(${this.state.pengeheftelser.length})`}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>                    
                </div>
                <div className={this.state.isOpened && this.state.pengeheftelser.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.pengeheftelser.map((p, index) => { return (<Pengeheftelse key={p.dokumentnummer+p.dokumentnavn} pengeheftelse={p} isLast={index==this.state.pengeheftelser.length-1} onEvent={this.props.onEvent} />)}) }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(PengeheftelseList)